<template>
  <div>
    <custom-callout
      class="mb-3 custom-callout"
      :opened="referral.isOpen"
      :controlled="true"
      :border-color="referral.color"
      @click:open="onToggle()"
    >
      <div class="row border-bottom py-3 m-0">
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Número de Referido:
          </div>
          <div class="color-black font-16 font-weight-bold">
            {{ referral.referralNumber }}
          </div>
        </div>
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Estudiante:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ referral.student }}
          </div>
        </div>
        <div
          class="col-md-6 col-12 col-spacing student-spacing justify-content-end d-flex"
        >
          <drop-down
            :items="actionItems"
            class="actions-dropdown pt-2 pr-4"
            normal-size
            :always-show-dropdown="true"
          />
        </div>
      </div>
      <div class="row py-3 m-0">
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal">
            Estatus:
          </div>
          <custom-balloon
            :background-color="referral.color"
            class="mt-2"
            :text="referral.statusName"
            dot
          />
        </div>
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Tipo de Referido:
          </div>
          <div class="color-black font-16 font-weight-normal">
            <custom-drop-down
              v-if="canUpdateReferralType"
              v-model="referralTypeSelected"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              :clearable="false"
              :options="referralTypesOptions"
              @input="onChangeReferralType"
            />
            <span v-else>
              {{ referralTypeSelected?.name | empty }}
            </span>
          </div>
        </div>
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Fecha de Referido:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ referral.referralDate | date }}
          </div>
        </div>
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            CAAT:
          </div>
          <div class="color-black font-16 font-weight-normal">
            <custom-drop-down
              v-if="canUpdateCaatType"
              v-model="caatSelected"
              fieldkey="id"
              fieldname="name"
              :options="caats"
              placeholder="Seleccione"
              @input="onChangeCaatType"
            />
            <span v-else>
              {{ caatSelected?.name | empty }}
            </span>
          </div>
        </div>
      </div>
      <template #edition>
        <div class="bg-light-gray p-2">
          <div class="bg-white py-3 px-md-3 rounded" v-if="templatesAreHidden">
            <referral-tabs
              :key="tabIndex"
              :referral="referral"
              :tab-index="tabIndex"
              @onTabChanged="onTabChanged"
            />
          </div>

          <div class="mt-md-4">
            <add-binnacle
              v-if="showAddBinnacle"
              v-model="model.binnacle"
              @cancel="handlerCloseAddBinnacle"
              @save="handlerAddBinnacle"
              is-referral
            />

            <reject-referral
              v-if="showRejectReferral"
              v-model="model.rejectReferral"
              @cancel="handlerCloseRejectReferral"
              @save="handlerRejectReferral"
            />

            <ajust-referral
              v-if="showAjustReferral"
              v-model="model.ajustReferral"
              @cancel="handlerCloseAjustReferral"
              @save="handlerAjustReferral"
            />

            <coordinate-appointment
              @cancel="hideCoordinateAppointmentSection"
              v-if="showCoordinateAppointment"
              @save="handlerCoordinateAppointment"
              :referral="referral"
            />
            <register-absence
              v-if="isRegisterAbsenceOpen && showAddAbsence"
              :referral="referral"
              v-model="model.adsence"
              @save="handlerSaveAbsence"
              @cancel="handlerCloseRegisterAbsence"
            />
            <upload-single-file
              v-if="showSingleFile"
              :referral="referral"
              :pei-at-service-id="referral.id"
              v-model="model.adsence"
              @cancel="hideSingleFileSection"
            />
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import CustomBalloon from 'custom-balloon';
import CustomDropDown from 'custom-drop-down';
import DropDown from 'dropdown';
import ReferralTabs from './ReferralTabs.vue';
import AddBinnacle from './components/AddBinnacle.vue';
import UploadSingleFile from './components/UploadSingleFile.vue';
import RejectReferral from './components/RejectReferral.vue';
import AjustReferral from './components/AjustReferral.vue';
import CoordinateAppointment from './components/CoordinateApointment.vue';
import RegisterAbsence from './components/RegisterAbsence.vue';
import mixAlert from '@/mixins/alert.mixin';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
import peiATServiceStatus from '@/utils/constants/peiATServiceStatus';
import peiAtReferralType from '@/utils/constants/peiAtReferralType';
import peiAtReferralTabs from '@/utils/constants/peiAtReferralTabs';
import { serialize as objectToFormData } from 'object-to-formdata';

const TEMPLATE_TAB_INDEX = {
  REGISTERABSENCE: 1,
  COORDINATEAPPOINMENT: 2,
  AJUSTREFERRAL: 3,
  REJECTREFERRAL: 4,
  ADDBINNACLE: 5,
  ADDABSENCE: 6,
  SINGLEFILE: 7,
};

const STATUSES_SORT_BY = {
  PENDINGAPPOINTMENT: 3,
  SERVED: 21,
};
const EVALUATION_REPORT_ROUTE_NAME = 'ReferralEvaluationReport';
const REFERRAL_DETAILS_ROUTE_NAME = 'ReferralDetails';

export default {
  name: 'ReferralRow',
  components: {
    CustomCallout,
    CustomBalloon,
    CustomDropDown,
    DropDown,
    ReferralTabs,
    AddBinnacle,
    UploadSingleFile,
    RegisterAbsence,
    RejectReferral,
    AjustReferral,
    CoordinateAppointment,
  },
  mixins: [mixAlert],
  props: {
    referral: {
      type: Object,
      required: true,
    },
    caats: {
      type: Array,
      required: true,
    },
    referralTypes: {
      type: Array,
      required: true,
    },
    isInventoryFlowEnabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      selectedTemplateTabIndex: null,
      caatSelected: null,
      referralTypeSelected: null,
      model: {
        rejectReferral: {
          reasonId: null,
          comment: null,
        },
        ajustReferral: {
          reasonId: null,
          comment: null,
        },
        binnacle: {
          attachment: null,
          attachmentId: null,
          comment: null,
          documentName: null,
        },
        adsence: {
          date: null,
          start: null,
          end: null,
          participants: null,
          caat: null,
          reasonId: null,
          comment: null,
        },
      },
      tabIndex: peiAtReferralTabs.AdditionalInfo,
      caat: null,
    };
  },
  computed: {
    templatesAreHidden() {
      return this.selectedTemplateTabIndex == null;
    },
    showAddBinnacle() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.ADDBINNACLE;
    },
    showAddAbsence() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.ADDABSENCE;
    },
    showRejectReferral() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.REJECTREFERRAL;
    },
    showCoordinateAppointment() {
      return (
        this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.COORDINATEAPPOINMENT
      );
    },
    showSingleFile() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.SINGLEFILE;
    },
    showAjustReferral() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.AJUSTREFERRAL;
    },
    actionItemsDynamic() {
      return this.referral.confPeiAtServiceStatus.map((status) => {
        return {
          name: status.action,
          icon: status.iconClass,
          border: 'bottom',
          color: status.colorStatus,
          click: () => eval(this[status.actionName]()),
        };
      });
    },
    actionItems() {
      return [
        {
          visible: () =>
            this.referral.referralTypeId !=
              peiAtReferralType.TechnicalAssistanceServiceRequest &&
            this.referral.hasEquipment,
          name: 'Información de Referido',
          icon: 'mr-1 far fa-file-export text-green',
          click: () => this.goToReferralDetails(),
        },
        {
          name: 'Información Adicional',
          icon: 'mr-1 far fa-circle-info text-green',
          click: () => this.viewAdditionalInfo(),
        },
        {
          name: 'Ver Documentos',
          icon: 'mr-1 far fa-file-download text-green',
          click: () => this.viewDocuments(),
          border:
            !this.referral.isEvaluated &&
            !(
              this.referral.referralTypeId ==
                peiAtReferralType.EquipmentRelatedServiceRequest ||
              this.referral.referralTypeId ==
                peiAtReferralType.TechnicalAssistanceServiceRequest
            )
              ? 'bottom'
              : null,
        },
        {
          name: 'Ver Documentos de Uso',
          icon: 'mr-1 far fa-file-search text-green',
          click: () => this.viewUsageDocuments(),
        },
        {
          visible: () =>
            (this.referral.referralTypeId ==
              peiAtReferralType.EquipmentRelatedServiceRequest ||
              this.referral.referralTypeId ==
                peiAtReferralType.TechnicalAssistanceServiceRequest) &&
            this.referral.statusId != peiATServiceStatus.PendienteAnalisis &&
            this.referral.statusId != peiATServiceStatus.PendienteDeterminacion,
          name: 'Servicios',
          border:
            !this.referral.isEvaluated &&
            (this.referral.referralTypeId ==
              peiAtReferralType.EquipmentRelatedServiceRequest ||
              this.referral.referralTypeId ==
                peiAtReferralType.TechnicalAssistanceServiceRequest)
              ? 'bottom'
              : null,
          icon: 'mr-1 fas fa-list text-green',
          click: () => this.goToReferralDetails(2),
        },

        {
          name: 'Ver Evaluación',
          icon: 'mr-1 far fa-file-contract text-green',
          click: () => this.goToEvaluationReport(),
          border:
            this.referral.isEvaluated &&
            this.referral.referralTypeId == peiAtReferralType.Regular
              ? 'bottom'
              : null,
          visible: () =>
            this.referral.isEvaluated &&
            this.referral.referralTypeId == peiAtReferralType.Regular,
        },
        {
          name: 'Ver Avalúo',
          icon: 'mr-1 far fa-file-check text-green',
          click: () => this.goToEvaluationReport(),
          border:
            this.referral.isEvaluated &&
            this.referral.referralTypeId == peiAtReferralType.Appraisal
              ? 'bottom'
              : null,
          visible: () =>
            this.referral.isEvaluated &&
            this.referral.referralTypeId == peiAtReferralType.Appraisal,
        },
        {
          name: 'Ver Validación',
          icon: 'mr-1 far fa-check-double text-green',
          border:
            this.referral.isEvaluated &&
            (this.referral.referralTypeId == peiAtReferralType.Validation ||
              this.referral.referralTypeId ==
                peiAtReferralType.EquipmentRelatedServiceRequest)
              ? 'bottom'
              : null,
          click: () => this.goToEvaluationReport(),
          visible: () =>
            this.referral.isEvaluated &&
            (this.referral.referralTypeId == peiAtReferralType.Validation ||
              this.referral.referralTypeId ==
                peiAtReferralType.EquipmentRelatedServiceRequest),
        },
        {
          name: 'Registrar Ausencia',
          icon: 'fas fa-user-times text-success',
          visible: () =>
            this.referral.referralTypeId == peiAtReferralType.Regular &&
            (this.referral.statusId ==
              peiATServiceStatus.PendienteDeEvaluacion ||
              this.referral.statusId ===
                peiATServiceStatus.PendienteDocumentarEvaluacion) &&
            !this.referral.isEvaluated &&
            this.referral.hasAppointmentCoordinated &&
            this.userHasPermissions(
              'technologyassistance.referralmanagment.absenceappointment'
            ),
          click: () => this.handlerOpenRegisterAbsence(),
        },
        {
          name: 'Evaluar',
          icon: 'mr-1 far fa-file-contract text-green',
          click: () => this.goToEvaluationReport(),
          visible: () => {
            return (
              !this.referral.isEvaluated &&
              this.referral.referralTypeId == peiAtReferralType.Regular &&
              this.userHasPermissions(
                'technologyassistance.referralmanagment.appraise'
              ) &&
              (this.referral.statusId ===
                peiATServiceStatus.PendienteDeEvaluacion ||
                this.referral.statusId ===
                  peiATServiceStatus.PendienteDocumentarEvaluacion)
            );
          },
        },
        {
          name: 'Avalúo',
          icon: 'mr-1 far fa-file-check text-green',
          click: () => this.goToEvaluationReport(),
          visible: () =>
            !this.referral.isEvaluated &&
            this.referral.referralTypeId == peiAtReferralType.Appraisal &&
            this.userHasPermissions(
              'technologyassistance.referralmanagment.appraise'
            ) &&
            this.referral.statusId === peiATServiceStatus.PendienteDeAvaluo,
        },

        {
          name: 'Validación',
          icon: 'mr-1 far fa-bell-exclamation text-green',
          click: () => this.goToEvaluationReport(),
          visible: () =>
            !this.referral.isEvaluated &&
            (this.referral.referralTypeId == peiAtReferralType.Validation ||
              this.referral.referralTypeId ==
                peiAtReferralType.EquipmentRelatedServiceRequest) &&
            this.userHasPermissions(
              'technologyassistance.referralmanagment.appraise'
            ) &&
            this.referral.statusId === peiATServiceStatus.PendienteDeValidacion,
        },
        {
          name: 'En Proceso de Análisis',
          icon: 'mr-1 far fa-folder text-green',
          click: () => this.changeStatusPendingDetermination(),
          visible: () =>
            this.referral.statusId === peiATServiceStatus.PendienteAnalisis &&
            this.userHasPermissions(
              'technologyassistance.statuschangereferralmanagment.analysisprocess'
            ),
        },
        {
          name: 'Aprobar',
          icon: 'mr-1 far fa-check text-green',
          click: () => this.changeStatusPendingApproval(),
          visible: () =>
            (this.referral.statusId ===
              peiATServiceStatus.PendienteDeterminacion ||
              this.referral.statusId === peiATServiceStatus.Rechazado) &&
            this.userHasPermissions(
              'technologyassistance.statuschangereferralmanagment.approve'
            ),
        },
        {
          name: 'Denegar',
          icon: 'mr-1 far fa-ban text-green',
          click: () => this.displayRejectReferral(),
          visible: () =>
            this.referral.statusId ===
              peiATServiceStatus.PendienteDeterminacion &&
            this.userHasPermissions(
              'technologyassistance.statuschangereferralmanagment.deny'
            ),
        },
        {
          label: 'Coordinar Cita',
          icon: 'mr-1 far fa-calendar-edit text-green',
          click: () => this.displayCoordinateAppointmentSection(),
          hasLine: true,
          visible: () =>
            this.referral.referralTypeId == peiAtReferralType.Regular &&
            this.userHasPermissions(
              'technologyassistance.referralmanagment.coordinateappointment'
            ) &&
            (this.referral.statusId == peiATServiceStatus.PendienteDeCita ||
              this.referral.statusId ==
                peiATServiceStatus.PendienteDeRecoordinarCita),
        },
        {
          name: this.isAcquisition
            ? 'Análisis de Adquisición'
            : 'Análisis de Requisición',
          icon: 'far fa-file-chart-pie text-success',
          visible: () =>
            this.userHasPermissions(
              'technologyassistance.referralmanagment.requisitionanalysis'
            ) &&
            [
              peiATServiceStatus.PendienteAnalisisRequisicion,
              peiATServiceStatus.PendienteDeRequisicion,
            ].includes(this.referral.statusId),
          click: () =>
            this.$router.push({
              name: 'RequisitionAnalysis',
              params: { id: this.referral.id },
            }),
        },
        {
          name: 'Ajustar',
          icon: 'mr-1 far fa-sliders-h text-green',
          click: () => this.displayAjustReferral(),
          visible: () =>
            this.referral.statusSortBy >= STATUSES_SORT_BY.PENDINGAPPOINTMENT &&
            this.referral.statusSortBy < STATUSES_SORT_BY.SERVED &&
            this.userHasPermissions(
              'technologyassistance.statuschangereferralmanagment.adjust'
            ),
        },
        {
          name: 'Añadir Bitácora',
          icon: 'far fa-comment text-green',
          click: () => this.handlerOpenAddBinnacle(),
        },
        {
          visible: () =>
            this.referral.statusId == peiATServiceStatus.Servido ||
            this.referral.statusId == peiATServiceStatus.Ajustado ||
            this.referral.statusId == peiATServiceStatus.Rechazado,
          name: 'Subir Expediente Estudiante',
          icon: 'mr-1 far fa-file-upload text-green',
          click: () => this.displaySingleFileSection(),
        },
        {
          name: 'Historial Bitácora',
          icon: 'mr-1 far fa-history text-green',
          border: 'top',
          click: () => this.viewBinnacleLog(),
        },
        {
          name: 'Historial de Estatus',
          icon: 'mr-1 far fa-history text-green',
          click: () => this.viewStatusLog(),
        },
        {
          name: 'Historial de Citas',
          icon: 'mr-1 far fa-history text-green',
          click: () => this.viewAppointmentLog(),
          visible: () => this.referral.hasAppointment,
        },
      ];
    },
    canUpdateReferralType() {
      const validPermission = this.userHasPermissions(
        'technologyassistance.referralmanagment.ReferralType.change'
      );
      if (!validPermission) return false;
      const validType = ![
        peiAtReferralType.EquipmentRelatedServiceRequest,
        peiAtReferralType.TechnicalAssistanceServiceRequest,
      ].includes(this.referral.referralTypeId);
      if (!validType) return false;
      const validStatus = [
        peiATServiceStatus.PendienteAnalisis,
        peiATServiceStatus.PendienteDeterminacion,
      ].includes(this.referral.statusId);
      if (!validStatus) return false;
      return true;
    },
    canUpdateCaatType() {
      return this.userHasPermissions(
        'technologyassistance.referralmanagment.CAAT.change'
      );
    },
    referralTypesOptions() {
      return this.referralTypes.filter(
        (x) => x.id !== this.referral.referralTypeId
      );
    },
    isRegisterAbsenceOpen() {
      return (
        this.showAddAbsence &&
        !this.showAddBinnacle &&
        !this.showAjustReferral &&
        !this.showRejectReferral &&
        !this.showCoordinateAppointmentSection
      );
    },
    isAcquisition() {
      return this.isInventoryFlowEnabled && Boolean(this.referral.hasCatalogId);
    },
  },
  watch: {
    referral: {
      handler() {
        this.caatSelected =
          this.referral.caatId !== null
            ? {
                id: this.referral.caatId,
                name: this.referral.caatName,
              }
            : null;
        this.referralTypeSelected = this.referralTypes.find(
          (x) => x.id === this.referral.referralTypeId
        );
      },
      deep: true,
      immediate: true,
    },
    'referral.isOpen': {
      handler() {
        if (!this.referral.isOpen) {
          this.selectedTemplateTabIndex = null;
        }
      },
      immediate: true,
    },
  },
  methods: {
    async onChangeReferralType(value) {
      if (!value) return;
      if (this.referral.referralTypeId === value.id) return;
      setTimeout(async () => {
        const isConfirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea cambiar el tipo de referido a ${value.name}?`,
          'Sí',
          'No'
        );
        if (!isConfirmed) {
          this.referralTypeSelected = this.referralTypes.find(
            (x) => x.id === this.referral.referralTypeId
          );
          return;
        }
        try {
          await referralAndEquipmentsservice.updateReferralType(
            this.referral.id,
            value.id
          );
          this.referral.referralTypeId = value.id;
        } catch (error) {
          this.referralTypeSelected = this.referralTypes.find(
            (x) => x.id === this.referral.referralTypeId
          );
          this.ShowToast('Error', error?.response?.data.message, 'error');
        }
      }, 100);
    },
    async onChangeCaatType(value) {
      if (!value) return;
      if (this.referral.caatId === value.id) return;
      setTimeout(async () => {
        const isConfirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea cambiar el tipo de CAAT a ${value.name}?`,
          'Sí',
          'No'
        );
        if (!isConfirmed) {
          this.caatSelected =
            this.referral.caatId !== null
              ? {
                  id: this.referral.caatId,
                  name: this.referral.caatName,
                }
              : null;
          return;
        }
        try {
          await referralAndEquipmentsservice.updateCaatType(
            this.referral.id,
            value.id
          );
          this.referral.caatId = value.id;
        } catch (error) {
          this.caatSelected =
            this.referral.caatId !== null
              ? {
                  id: this.referral.caatId,
                  name: this.referral.caatName,
                }
              : null;
          this.ShowToast('Error', error?.response?.data.message, 'error');
        }
      }, 100);
    },
    displayCoordinateAppointmentSection() {
      this.referral.isOpen = true;
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.COORDINATEAPPOINMENT;
    },
    hideCoordinateAppointmentSection() {
      this.referral.isOpen = false;
      this.selectedTemplateTabIndex = null;
    },
    displaySingleFileSection() {
      this.referral.isOpen = true;
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.SINGLEFILE;
    },
    hideSingleFileSection() {
      this.referral.isOpen = false;
      this.selectedTemplateTabIndex = null;
    },
    async handlerAddBinnacle() {
      const { classificationId } = this.model.binnacle;

      const payload = objectToFormData({
        ...this.model.binnacle,
        classificationId: (classificationId || {}).id,
        peiAtServiceId: this.referral.id,
      });

      const { data } = await referralAndEquipmentsservice
        .saveBinnacle(payload)
        .catch((error) => {
          this.ShowToast('Error', error?.response?.data.message, 'error');
        });
      if (data) {
        this.model.binnacle = {
          attachment: null,
          attachmentId: null,
          comment: null,
          documentName: null,
        };
        this.ShowToast(
          'Éxito',
          'Se ha guardado la bitácora correctamente',
          'success'
        );
      }
      this.handlerCloseAddBinnacle();
    },
    handlerRejectReferral() {
      this.handlerCloseRejectReferral();
      const payload = {
        peiAtServiceId: this.referral.id,
        reasonId: this.model.rejectReferral.reasonId?.id,
        comment: this.model.rejectReferral.comment,
      };
      referralAndEquipmentsservice
        .rejectReferral(payload)
        .catch((error) => {
          this.ShowToast('Error', error?.response?.data.message, 'error');
        })
        .then(() => {
          this.model.rejectReferral = {
            comment: null,
            reasonId: null,
          };
          this.ShowToast(
            'Éxito',
            'El estatus ha sido cambiado exitosamente.',
            'success'
          );
          this.$emit('statusChanged');
        });
    },
    handlerAjustReferral() {
      this.handlerCloseAjustReferral();
      const payload = {
        peiAtServiceId: this.referral.id,
        reasonId: this.model.ajustReferral.reasonId?.id,
        comment: this.model.ajustReferral.comment,
      };
      referralAndEquipmentsservice
        .ajustReferral(payload)
        .catch((error) => {
          this.ShowToast('Error', error?.response?.data.message, 'error');
        })
        .then(() => {
          this.model.ajustReferral = {
            comment: null,
            reasonId: null,
          };
          this.ShowToast(
            'Éxito',
            'El estatus ha sido cambiado exitosamente.',
            'success'
          );
          this.$emit('statusChanged');
        });
    },
    handlerOpenAddBinnacle() {
      this.$emit('open', this.referral);
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.ADDBINNACLE;
    },
    handlerOpenRegisterAbsence() {
      this.$emit('open', this.referral);
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.ADDABSENCE;
    },
    handlerCloseAddBinnacle() {
      this.model.binnacle = {};
      this.selectedTemplateTabIndex = null;
      this.$emit('close', this.referral);
    },
    handlerCloseRejectReferral() {
      this.selectedTemplateTabIndex = null;
      this.$emit('close', this.referral);
    },
    handlerCloseAjustReferral() {
      this.selectedTemplateTabIndex = null;
      this.$emit('close', this.referral);
    },
    viewAppointmentLog() {
      this.selectedTemplateTabIndex = null;
      this.referral.isOpen = false;
      this.$emit('open', this.referral);
      this.tabIndex = peiAtReferralTabs.AppointmentHistory;
    },
    viewDocuments() {
      this.selectedTemplateTabIndex = null;
      this.referral.isOpen = false;
      this.$emit('open', this.referral);
      this.tabIndex = peiAtReferralTabs.Documents;
    },
    viewUsageDocuments() {
      this.selectedTemplateTabIndex = null;
      this.referral.isOpen = false;
      this.$emit('open', this.referral);
      this.tabIndex = peiAtReferralTabs.UsageDocuments;
    },
    viewAdditionalInfo() {
      this.selectedTemplateTabIndex = null;
      this.referral.isOpen = false;
      this.$emit('open', this.referral);
      this.tabIndex = peiAtReferralTabs.AdditionalInfo;
    },
    viewBinnacleLog() {
      this.selectedTemplateTabIndex = null;
      this.referral.isOpen = false;
      this.$emit('open', this.referral);
      this.tabIndex = peiAtReferralTabs.LogHistory;
    },
    viewStatusLog() {
      this.selectedTemplateTabIndex = null;
      this.referral.isOpen = false;
      this.$emit('open', this.referral);
      this.tabIndex = peiAtReferralTabs.StatusHistory;
    },
    async changeStatus(fromStatus, toStatus, statusId) {
      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `Está seguro que desea cambiar el estatus de ${fromStatus} a ${toStatus}?`,
        'Sí',
        'No'
      );
      if (!isConfirmed) {
        return;
      }

      await referralAndEquipmentsservice.changeStatus(this.referral.id, {
        statusId: statusId,
      });

      this.ShowToast(
        'Éxito',
        'El estatus ha sido cambiado exitosamente.',
        'success'
      );

      this.$emit('statusChanged');
    },
    async changeStatusPendingDetermination() {
      await this.changeStatus(
        'Pendiente de Análisis',
        'Pendiente de Determinación',
        peiATServiceStatus.PendienteDeterminacion
      );
    },
    async changeStatusPendingApproval() {
      let statusName, serviceStatus;
      if (this.referral.referralTypeId === peiAtReferralType.Appraisal) {
        statusName = 'Pendiente de Avalúo';
        serviceStatus = peiATServiceStatus.PendienteDeAvaluo;
      } else if (
        this.referral.referralTypeId === peiAtReferralType.Validation
      ) {
        statusName = 'Pendiente de Validación';
        serviceStatus = peiATServiceStatus.PendienteDeValidacion;
      } else if (
        this.referral.referralTypeId ===
          peiAtReferralType.EquipmentRelatedServiceRequest ||
        this.referral.referralTypeId ===
          peiAtReferralType.TechnicalAssistanceServiceRequest
      ) {
        statusName = 'Pendiente de Clasificación';
        serviceStatus = peiATServiceStatus.PendienteDeClasificacion;
      } else {
        statusName = 'Pendiente de Cita';
        serviceStatus = peiATServiceStatus.PendienteDeCita;
      }
      await this.changeStatus(
        this.referral.statusName,
        statusName,
        serviceStatus
      );
    },
    onTabChanged(index) {
      this.tabIndex = index;
    },
    async onToggle() {
      this.selectedTemplateTabIndex = null;

      if (this.referral.isOpen) {
        this.$emit('close', this.referral);
        return;
      }
      this.$emit('open', this.referral);
    },
    async handlerCoordinateAppointment() {
      this.$emit('statusChanged');
    },
    async handlerSaveAbsence() {
      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea cambiar el estatus del referido de ${this.referral.statusName} a Pendiente de Recoordinar Cita?`,
        'Sí',
        'No'
      );
      if (!isConfirmed) return;
      const payload = {
        appointmentDate: this.model.adsence.date,
        timeFrom: this.model.adsence.start,
        timeTo: this.model.adsence.end,
        reasonId: this.model.adsence.reasonId.id,
        reason: this.model.adsence.reasonId.name,
        comment: this.model.adsence.comment,
        appointmentId: this.model.adsence.appointmentId,
        peiAtServiceId: this.referral.id,
        participants: this.model.adsence.participants.map((item) => ({
          participantId: item.participantId,
          caatId: item.caatId,
        })),
      };
      const {
        data,
      } = await referralAndEquipmentsservice.saveAppointmentAbsence(payload);
      if (data) {
        this.ShowToast(
          'Éxito',
          'Se ha guardado la ausencia correctamente',
          'success'
        );
        this.model.adsence = {
          date: null,
          start: null,
          end: null,
          participants: null,
          caat: null,
          reasonId: null,
          comment: null,
        };
        this.handlerCloseRegisterAbsence();
      }
    },
    handlerCloseRegisterAbsence() {
      this.selectedTemplateTabIndex = null;

      this.$emit('close', this.referral);
      this.$emit('statusChanged');
    },
    goToEvaluationReport() {
      this.$router.push({
        name: EVALUATION_REPORT_ROUTE_NAME,
        params: { id: this.referral.id },
      });
    },
    goToReferralDetails(type = 1) {
      this.$router.push({
        name: REFERRAL_DETAILS_ROUTE_NAME,
        params: {
          id: this.referral.id,
          type: type,
        },
      });
    },
    displayRejectReferral() {
      this.$emit('open', this.referral);
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.REJECTREFERRAL;
    },
    displayAjustReferral() {
      this.$emit('open', this.referral);
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.AJUSTREFERRAL;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep div.custom-callout div.bg-secondary-3 {
  border-bottom: solid #ffffff 2px !important;
}
::v-deep .width-container {
  width: 100% !important;
}

.custom-datetime-picker-container ::v-deep .menu-right {
  right: auto !important;
}
</style>
